const technicalSkills = [
    {
        name: 'Python',
        category: 'Programming',
        level: 'Expert',
        projectIds: [
            'gdp-happiness-analysis',
            'finger-detection-opencv',
            'cifar10-cnn-classifier'
        ],
        experienceIds: [3]
    },
    {
        name: 'TypeScript',
        category: 'Programming',
        level: 'Expert',
        projectIds: [
            'subtrackr-subscription-tracker',
            'quickpoll-vue-realtime-polling',
            'clinicstreamdeck-assistant'
        ],
        experienceIds: []
    },
    {
        name: 'JavaScript',
        category: 'Programming',
        level: 'Expert',
        projectIds: ['photofx-hybrid-mobile-app'],
        experienceIds: [1]
    },
    {
        name: 'C (Programming Language)',
        category: 'Programming',
        level: 'Advanced',
        projectIds: ['stm32-ecg-signal-transmission'],
        experienceIds: []
    },
    {
        name: 'C++',
        category: 'Programming',
        level: 'Advanced',
        projectIds: ['custom-dancing-robot'],
        experienceIds: []
    },
    {
        name: 'React.js',
        category: 'Frontend',
        level: 'Expert',
        projectIds: [],
        experienceIds: [1]
    },
    {
        name: 'Vue 3',
        category: 'Frontend',
        level: 'Expert',
        projectIds: ['quickpoll-vue-realtime-polling'],
        experienceIds: []
    },
    {
        name: 'Angular 19',
        category: 'Frontend',
        level: 'Advanced',
        projectIds: ['subtrackr-subscription-tracker'],
        experienceIds: []
    },
    {
        name: 'HTML5',
        category: 'Frontend',
        level: 'Expert',
        projectIds: [
            'photofx-hybrid-mobile-app',
            'clinicstreamdeck-assistant'
        ],
        experienceIds: [1]
    },
    {
        name: 'CSS',
        category: 'Frontend',
        level: 'Expert',
        projectIds: [
            'photofx-hybrid-mobile-app',
            'clinicstreamdeck-assistant'
        ],
        experienceIds: [1]
    },
    {
        name: 'Node.js',
        category: 'Backend',
        level: 'Expert',
        projectIds: [
            'subtrackr-subscription-tracker',
            'clinicstreamdeck-assistant'
        ],
        experienceIds: [1]
    },
    {
        name: 'Express',
        category: 'Backend',
        level: 'Expert',
        projectIds: ['subtrackr-subscription-tracker'],
        experienceIds: [1]
    },
    {
        name: 'MySQL',
        category: 'Backend',
        level: 'Advanced',
        projectIds: ['subtrackr-subscription-tracker'],
        experienceIds: []
    },
    {
        name: 'Pandas',
        category: 'Data Science',
        level: 'Expert',
        projectIds: ['gdp-happiness-analysis'],
        experienceIds: []
    },
    {
        name: 'NumPy',
        category: 'Data Science',
        level: 'Expert',
        projectIds: [
            'gdp-happiness-analysis',
            'cifar10-cnn-classifier'
        ],
        experienceIds: []
    },
    {
        name: 'TensorFlow',
        category: 'Data Science',
        level: 'Expert',
        projectIds: ['cifar10-cnn-classifier'],
        experienceIds: []
    },
    {
        name: 'PyTorch',
        category: 'Data Science',
        level: 'Expert',
        projectIds: ['finger-detection-opencv'],
        experienceIds: []
    },
    {
        name: 'OpenCV',
        category: 'Data Science',
        level: 'Advanced',
        projectIds: ['finger-detection-opencv'],
        experienceIds: []
    },
    {
        name: 'Matplotlib',
        category: 'Data Science',
        level: 'Advanced',
        projectIds: [
            'gdp-happiness-analysis',
            'cifar10-cnn-classifier'
        ],
        experienceIds: []
    },
    {
        name: 'AWS',
        category: 'Cloud',
        level: 'Expert',
        projectIds: [],
        experienceIds: [1]
    },
    {
        name: 'GCP',
        category: 'Cloud',
        level: 'Expert',
        projectIds: [],
        experienceIds: [1]
    },
    {
        name: 'Microsoft Azure',
        category: 'Cloud',
        level: 'Advanced',
        projectIds: [],
        experienceIds: [1]
    },
    {
        name: 'Docker',
        category: 'DevOps',
        level: 'Expert',
        projectIds: ['quickpoll-vue-realtime-polling'],
        experienceIds: []
    },
    {
        name: 'Arduino',
        category: 'Hardware',
        level: 'Expert',
        projectIds: ['custom-dancing-robot'],
        experienceIds: []
    },
    {
        name: 'STM32',
        category: 'Hardware',
        level: 'Expert',
        projectIds: ['stm32-ecg-signal-transmission'],
        experienceIds: []
    },
    {
        name: 'PCB Design',
        category: 'Hardware',
        level: 'Advanced',
        projectIds: ['custom-dancing-robot'],
        experienceIds: []
    },
    {
        name: 'Soldering',
        category: 'Hardware',
        level: 'Advanced',
        projectIds: ['custom-dancing-robot'],
        experienceIds: []
    },
    {
        name: 'Vite',
        category: 'Tools',
        level: 'Advanced',
        projectIds: ['quickpoll-vue-realtime-polling'],
        experienceIds: []
    },
    {
        name: 'Jest',
        category: 'Tools',
        level: 'Advanced',
        projectIds: ['quickpoll-vue-realtime-polling'],
        experienceIds: []
    },
    {
        name: 'JSON',
        category: 'Tools',
        level: 'Expert',
        projectIds: ['clinicstreamdeck-assistant'],
        experienceIds: []
    },
    {
        name: 'Axios',
        category: 'Tools',
        level: 'Expert',
        projectIds: ['clinicstreamdeck-assistant'],
        experienceIds: []
    },
    {
        name: 'Apache Cordova',
        category: 'Tools',
        level: 'Advanced',
        projectIds: ['photofx-hybrid-mobile-app'],
        experienceIds: []
    },
    {
        name: 'Android Studio',
        category: 'Tools',
        level: 'Advanced',
        projectIds: ['photofx-hybrid-mobile-app'],
        experienceIds: []
    },
    {
        name: 'Gradle',
        category: 'Tools',
        level: 'Advanced',
        projectIds: ['photofx-hybrid-mobile-app'],
        experienceIds: []
    }
];

export default technicalSkills;
